import React, { Component } from "react";
import { CustomInput } from "reactstrap";
import "./style.css";

class CheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = this.props.form_group;
  }

  checkboxChange(e) {
    let clone = { ...this.state };
    let new_clone = clone.checkbox_list.map(checkbox => {
      let field_name =
        "form[" + this.state.group_id + "]" + "[" + checkbox.name + "]";
      if (field_name == e.target.name) {
        checkbox.value = e.target.checked;
      }
      return checkbox;
    });

    this.setState(
      {
        new_clone
      },
      () => {
        this.props.checkboxChange(this.state);
      }
    );
  }

  checkbox_maker() {
    return this.state.checkbox_list.map((checkbox, index) => {
      let field_name;
      let label;
      if (checkbox.name == "pro") {
        field_name = "pro";
        label = `${checkbox.label} (Buy Pro version for this)`;
      } else {
        field_name =
          "form[" + this.state.group_id + "]" + "[" + checkbox.name + "]";
        label = checkbox.label;
      }

      return (
        <div className="col-12 col-sm-3 my-3" key={index}>
          <CustomInput
            type="checkbox"
            name={field_name}
            checked={checkbox.value == undefined ? false : checkbox.value}
            onChange={e => {
              this.checkboxChange(e);
            }}
            id={checkbox.name + "_id_" + index}
            label={label}
            disabled={checkbox.name == "pro" ? "disabled" : false}
            className={checkbox.name == "pro" ? "is-pro" : ""}
            inline
          />
          {checkbox.desc != undefined && checkbox.desc != "" ? (
            <img
              src={window.css_js_manager.tip}
              className="pi-icon"
              title={checkbox.desc}
            />
          ) : (
            ""
          )}
        </div>
      );
    });
  }

  render() {
    return (
      <div className="card text-dark bg-light mb-3 mt-3">
        <div className="card-header">
          <h4>{this.props.form_group.title}</h4>
        </div>
        <div className="card-body">
          <div className="row">{this.checkbox_maker()}</div>
        </div>
      </div>
    );
  }
}

export default CheckBox;
